import {t} from 'i18next';

export function greetingForTime(now: number): string {
  const hour = new Date(now).getHours();
  if (hour >= 21 || hour < 5) {
    return t('dashboard_greeting_midnight').toString();
  }
  if (hour < 12) {
    return t('dashboard_greeting_morning').toString();
  }
  if (hour < 17) {
    return t('dashboard_greeting_afternoon').toString();
  }
  return t('dashboard_greeting_evening').toString();
}
